<div class="view-container">
    <div style="text-align: center; margin-bottom: 32px;">
        <h1>Cult of Jar Events</h1>
        <p>Join our regular community events!</p>
    </div>

    @if (events.length === 0) {
        <mat-card>
            <mat-card-content>
                <div style="text-align: center; padding: 32px;">
                    <app-icon style="font-size: 48px; color: var(--mat-sys-on-surface-variant); margin-bottom: 16px;" icon="event_busy"></app-icon>
                    <h3>No events scheduled</h3>
                    <p class="variant">Check back later for upcoming community events!</p>
                </div>
            </mat-card-content>
        </mat-card>
    } @else {
        <div class="events-grid">
            @for (event of events; track event.id) {
                <mat-card class="event-card" [class.upcoming]="isUpcoming(event.time)" [class.patron-only]="event.patron_only >= 0">
                    <div class="event-image">
                        <img [src]="event.image" [alt]="event.title" [class.blurred]="event.patron_only >= 0" />
                        @if (isUpcoming(event.time)) {
                            <div class="upcoming-badge">
                                <mat-icon>schedule</mat-icon>
                                <span>Upcoming</span>
                            </div>
                        }
                    </div>
                    
                    <mat-card-header>
                        <mat-card-title [class.blurred]="event.patron_only >= 0">{{ event.title }}</mat-card-title>
                        <mat-card-subtitle [class.blurred]="event.patron_only >= 0">
                            <mat-icon>schedule</mat-icon>
                            {{ formatEventDate(event.time) }}
                        </mat-card-subtitle>
                    </mat-card-header>
                    
                    <mat-card-content>
                        <p [class.blurred]="event.patron_only >= 0">{{ event.description }}</p>
                    </mat-card-content>
                    
                    <mat-card-actions align="end">
                        <button mat-button [routerLink]="[event.cta_link]">
                            {{ event.cta_text }}
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    
                    </mat-card-actions>
                    
                    @if (event.patron_only >= 0) {
                        <div class="patron-overlay">
                            <div class="patron-content">
                                <div class="patron-badge">
                                    <mat-icon>star</mat-icon>
                                    <span>Patron Only</span>
                                </div>
                                <p class="patron-description">
                                    This exclusive event is available only to our Patreon supporters.<br>
                                    (
                                        <span [style.color]="tiers[event.patron_only.toString()].color">{{getPatreonTierName(event.patron_only)}}</span>
                                        and above )
                                </p>
                                <button mat-flat-button color="primary" [routerLink]="['/patreon']">
                                    <mat-icon>favorite</mat-icon>
                                    Become a Patron
                                </button>
                            </div>
                        </div>
                    }
                </mat-card>
            }
        </div>
    }
</div>
